import cfac22 from 'js/library/utils/cfac22';
import React, { useEffect, useState } from 'react';

export const HomeImage = () => {
  const verifyLanguage = localStorage.getItem('i18nextLng')
    ? localStorage.getItem('i18nextLng').replace('-', '_')
    : 'pt_BR';
  const [bannerMarketplace, setBannerMarketplace] = useState('');

  useEffect(() => {
    function bannerHiden() {
      if (verifyLanguage === 'pt_BR') {
        return (
          <a
            href="https://marketplace.triibo.com.br/triibo-vip/?utm_source=triibo_web_app&utm_medium=banner_direita&utm_campaign=assine_o_triibo_v.i.p"
            target="new"
          >
            <img alt="" width="100%" src={cfac22('STORAGE_URL') + cfac22('bannerImage')} />
          </a>
        );
      } else {
        return null;
      }
    }

    setBannerMarketplace(bannerHiden());
  }, [verifyLanguage]);

  return <div className="home-image-container">{bannerMarketplace}</div>;
};

export default HomeImage;
